import Mail from '@/assets/svg/ios-mail.svg'
import WhatsApp from '@/assets/svg/logo-whatsapp.svg'
import Slack from '@/assets/svg/logo-slack.svg'
import LinkedIn from '@/assets/svg/logo-linkedin.svg'

const navSocial = [{
  icon: Mail,
  title: 'E-mail',
  url: 'mailto:abner.simoes@hotmail.com'
},{
  icon: WhatsApp,
  title: 'WhatsApp',
  url: 'https://api.whatsapp.com/send?1=pt_BR&phone=5511972377486'
},{
  icon: Slack,
  title: 'Slack',
  url: 'http://abnersimoes.slack.com'
},{
  icon: LinkedIn,
  title: 'LinkedIn',
  url: 'https://www.linkedin.com/in/abner-simoes/'
}]

export default {

  namespaced: true,

  state: {
    home: {
      title: null,
      subtitle: null,
      nav: []
    },
    about: {
      title: 'Sobre',
      subtitle: 'experiência profissional',
      nav: []
    },
    projects: {
      title: 'Portfólio',
      subtitle: 'principais projetos',
      nav: []
    },
    contact: {
      title: 'Contato',
      nav: navSocial
    },
    navSocial
  },
  
  getters: {
  },

  mutations: {
  },

  actions: {
  }
}